import React from 'react';
import ServiceBookingPage from '../ServiceBookingPage';

const packs = [
  {
    id: 'starter',
    emoji: '🥉',
    name: 'Starter Plan',
    description: '4 x 2h sessions per month (1 per week)',
    price: 8000000,
    duration: 'Per month',
    features: ['4 sessions of 2h', '2 cam + 2 mics', 'Technician included', 'Priority booking', 'Save Rp 1.6M/month']
  },
  {
    id: 'creator',
    emoji: '🥈',
    name: 'Creator Plan',
    description: '8 x 2h sessions per month (2 per week)',
    price: 18000000,
    duration: 'Per month',
    popular: true,
    features: ['8 sessions of 2h', '2 cam + 2 mics', '2 free reels/month', '-10% on all add-ons', 'Save Rp 3.2M/month']
  },
  {
    id: 'pro',
    emoji: '🥇',
    name: 'Pro Plan',
    description: '2 full days (8h) per month',
    price: 32000000,
    duration: 'Per month',
    features: ['2 full days of 8h', '3 cam + 4 mics', '4 free episodes/month', '6 free reels/month', '-15% on add-ons', 'Save Rp 9.6M/month']
  },
  {
    id: 'agency',
    emoji: '💎',
    name: 'Agency Plan',
    description: '3 full days (8h) per month',
    price: 55000000,
    duration: 'Per month',
    features: ['3 full days of 8h', 'Premium equipment', 'Unlimited editing', '10 free reels/month', '1 photo session/month', '-20% on all services']
  }
];

const addons = [];

const customFields = [
  { id: 'company_name', label: 'Company / Brand name', type: 'text', placeholder: 'Your company or brand...' },
  { id: 'content_type', label: 'Content type / niche', type: 'text', placeholder: 'Business, lifestyle, tech...' },
  { id: 'num_users', label: 'How many people will use the studio?', type: 'number', placeholder: '1' },
  { id: 'start_month', label: 'Preferred start month', type: 'text', placeholder: 'January 2026' }
];

export default function MonthlyPlansBookingPage() {
  return (
    <ServiceBookingPage
      serviceType="monthly_plan"
      serviceTitle="Monthly Plans"
      serviceSubtitle="Studio subscription with savings"
      packs={packs}
      addons={addons}
      customFields={customFields}
      backLink="/services/monthly-plans"
    />
  );
}
